// Story 213 — the only file that knows the vision routes and fields of Sun (03-dominio §C1-C2).
import { apiDelete, apiGet, apiGetFile, apiPost, apiPut } from '../generic/Api_Functions'

export const getVisionSession = () => apiGet('vision/session')

// VisionFrameDto v2: exactly one of image / cameraError, and no deviceId.
export const sendVisionFrame = (image, cameraError) => apiPost('vision/frame', {
  image: cameraError ? null : image,
  cameraError: cameraError || null
})

// RN9: asks Sun to end the vigilance; `watched:false` if accepted, the current state if refused.
export const leaveVision = () => apiPost('vision/leave', {})

// C1 v2: the catalog of markable screens with their mark, readable by any authenticated user (H-v2-18).
export const getVisionScreens = () => apiGet('vision/screens')

// C15.2 (reopening 3, ADMIN or SUPERADMIN): every direct mark of a type, with the current name of its element ('' when it no
// longer exists) and, for products and orders, its cascade.
export const getSensitiveMarks = (type) => apiGet('vision/sensitive-marks', { type })

// C15.2: what can be protected of a type, searched by name (at most 20, ordered by name); `sensitive` is its direct mark.
export const getSensitiveCandidates = (type, q) => apiGet('vision/sensitive-candidates', { type, q })

// Atomic batch [{type, key, sensitive}]; only the elements that change.
export const putSensitiveMarks = (marks) => apiPut('vision/sensitive-marks', marks)

export const getVisionIncidents = (params) => apiGet('vision/incidents', params)

// C17.5 (reopening 5, ADMIN or SUPERADMIN): the phone image of an incident, only when asked for (RN160), as a blob that is
// never kept; Sun records the view before serving it (RN159).
export const getEvidenceImage = (id) => apiGetFile('vision/incidents/' + encodeURIComponent(id) + '/evidence/image').then((response) => response.blob())

// C17.5: who viewed the phone image of an incident, the 20 most recent and the total.
export const getEvidenceViews = (id) => apiGet('vision/incidents/' + encodeURIComponent(id) + '/evidence/views')

// C17.10 (C17b, ADMIN or SUPERADMIN): delete the phone image of one incident; Sun answers its evidence, now DELETED_BY_ADMIN.
export const deleteEvidenceImage = (id) => apiDelete('vision/incidents/' + encodeURIComponent(id) + '/evidence/image')

// C17.10: delete the phone images of the chosen incidents (1-200); Sun answers {deleted, skipped}.
export const deleteEvidenceImages = (incidentIds) => apiPost('vision/incidents/evidence/delete', { incidentIds })

// C11.2, SETTINGS: marks per type, vigilances in force and the state of the vision service.
export const getVisionSummary = () => apiGet('vision/summary')

// C16.4 (reopening 4, ADMIN or SUPERADMIN): the open sessions of MIC, by `since`, each with an opaque id.
export const getVisionSessions = () => apiGet('vision/sessions')

// C16.4: watch a session (taking the slot of `instead` when every slot is taken) or stop watching it; Sun answers the
// whole list. Only the opaque id of the list travels, never a session key.
export const putVisionSession = (id, body) => apiPut('vision/sessions/' + encodeURIComponent(id), body)

// C17.10 (ADMIN or SUPERADMIN): how many phone images are available right now, and deleting them all at once (only the
// images; the incidents stay). A POST with its own route, so that no DELETE without an id can delete everything.
export const getEvidenceCount = () => apiGet('vision/incidents/evidence/count')
export const deleteAllEvidence = () => apiPost('vision/incidents/evidence/delete-all', {})
